import { createContext, useContext } from "react";
import type { EmbeddedPodlets } from "./types.ts";

export const createPodletContext = <PodletNames extends string>() => {
  const PodletsContext = createContext<EmbeddedPodlets<PodletNames> | undefined>(undefined);

  type PodletsProviderProps = {
    children: React.ReactNode;
    podlets: EmbeddedPodlets<PodletNames>;
  };

  function PodletsProvider(props: PodletsProviderProps) {
    const { children, podlets } = props;

    return <PodletsContext value={podlets}>{children}</PodletsContext>;
  }

  function usePodlets(): EmbeddedPodlets<PodletNames> {
    const context = useContext(PodletsContext);
    if (typeof context === "undefined") {
      throw new Error("usePodlets must be used within an PodletsProvider");
    }
    return context;
  }

  return { PodletsProvider, usePodlets };
};
